import { Expose } from "class-transformer";
import { IsDefined, IsInt, IsString } from "class-validator";

import { GField, GInt, GObjectType } from "../graphql";

@GObjectType("HostAgency")
export class HostAgencyAndTravelAgentCount {
    @IsDefined()
    @Expose()
    @GField()
    @IsString()
    public _id: string;

    @IsDefined()
    @GField()
    @Expose()
    @IsString()
    public name: string;

    @IsDefined()
    @GField(() => GInt)
    @Expose()
    @IsInt()
    public approvedTravelAgentCount: number;
}
